import { getAllegroReturnPolicies } from '../../../api/allegro/returnpolicy/returnPolicy';
import { AllegroReturnPolicy } from '../../../api/allegro/returnpolicy/returnPolicyTypes';
import { fetchAllPages, swallowUnauthorized } from '../utils';

const PAGE_SIZE = 60;

export default async function fetchAllegroReturnPolicies(
  marketplaceCode: string,
  signal?: AbortSignal,
): Promise<AllegroReturnPolicy[]> {
  return swallowUnauthorized(
    () => fetchAllPages(
      async (offset, limit) => {
        const page = await getAllegroReturnPolicies(marketplaceCode, offset, limit, signal);

        return {
          items: page.returnPolicies,
          totalCount: page.count,
        };
      },
      PAGE_SIZE,
    ),
    [],
  );
}
